export default __webpack_public_path__ + "static/media/IMG_1665.cf59dc22.jpg";